
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs';
import { throwError } from 'rxjs';
import { timer} from 'rxjs';
import { SharedService } from '../services/shared.service';
import { ErrorService } from '../services/error.service';

const LOADING_CLOSE_DELAY_MS = 3000;
export const authInterceptor: HttpInterceptorFn = (req, next) => {

	const injector = inject(Injector);

	const token = localStorage.getItem('token');
	if (token) {
		const cloned = req.clone({
			setHeaders: { Authorization: `Bearer ${token}` }
		});
		return next(cloned).pipe(
			catchError((err: HttpErrorResponse) => {
				console.log(`authInterceptor ${err.status}`, err)
				if (err.status === 401) {
					// redirect_to_login();
					const errorService = injector.get(ErrorService);
					errorService.handleUnauthorized();
				}
				// control endBatchLoading
				const sharedService = injector.get(SharedService);
				timer(LOADING_CLOSE_DELAY_MS).subscribe(() => {
					// console.log('3s después, estado:', sharedService.loading_is_visible);
					if (sharedService.loading_is_visible) {
						sharedService.endBatchLoading()
						 .catch(e => console.error("Error closing batch loading desde authInterceptor", e));
					}
					
				});
				// end control endBatchLoading

				return throwError(() => err);
			})
		);;
	}
	return next(req);
};
